import api from '@/utils/axios';

const ktbService = {
  async findDaily(maturityRangeType, date) {
    try {
      const data = await api.get('/api/v1/transaction/daily', {
        maturityRangeType: maturityRangeType,
        date: date,
      });
      return Array.isArray(data)
        ? data.map(tx => {
            return {
              id: tx.id,
              type: tx.type,
              time: tx.time,
              spreadBp: tx.spreadBp,
            };
          })
        : [];
    } catch (error) {
      console.error('Error fetching KTB data:', error);
      throw error;
    }
  },

  async findBenchmarksByBondType(bondType) {
    try {
      const data = await api.get('/api/v1/benchmarks', {
        bondType: bondType,
      });
      return Array.isArray(data)
        ? data.map(benchmark => {
            return {
              id: benchmark.id,
              bondType: benchmark.bondType,
              code: benchmark.code,
              bondName: benchmark.bondName,
              benchmarkType: benchmark.benchmarkType,
              maturityDate: benchmark.maturityDate,
              yield: benchmark.yield,
            };
          })
        : [];
    } catch (error) {
      console.error('Error fetching KTB benchmarks:', error);
      throw error;
    }
  },

  async updateBenchmarks(id, _yield, maturityDate, code, bondName) {
    try {
      await api.patch('/api/v1/benchmarks/update', {
        id: id,
        yield: _yield,
        maturityDate: maturityDate,
        code: code,
        bondName: bondName,
      });
    } catch (error) {
      console.error('Error updating KTB benchmarks:', error);
      throw error;
    }
  },

  // KTB 견적 목록 API (날짜별)
  async findKtbQuotes(date) {
    try {
      const data = await api.get('/api/v1/quote/ktb', {
        date: date,
      });
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error('Error fetching KTB quotes:', error);
      throw error;
    }
  },

  // 새로운 KTB 채권 목록 API
  async findAllKtbBonds() {
    try {
      const data = await api.get('/api/v1/ktb-bonds');
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error('Error fetching KTB bonds:', error);
      throw error;
    }
  },

  // KTB 채팅 데이터 API
  async findKtbChat(date, code) {
    try {
      const data = await api.get('/api/v1/quote/ktb/chat', {
        date: date,
        code: code,
      });
      return Array.isArray(data) ? data : [];
    } catch (error) {
      console.error('Error fetching KTB chat:', error);
      throw error;
    }
  },
};

export default ktbService;
